import StatisticsCard from "./StatisticsCard";

export default StatisticsCard;
